import { PromotionChallengeForm } from './PromotionChallengeForm'
import { withPromotionChallengeForm } from './withPromotionChallengeForm'

const Connected = withPromotionChallengeForm(PromotionChallengeForm)

export { Connected as PromotionChallengeForm }
